export enum GridRequestMethod {
  GET,
  POST
}
